import { useEffect, useMemo, useState } from "react";
import { auth, db } from "../../components/firebase";
import { collection, doc, onSnapshot, query, where, orderBy, limit } from "firebase/firestore";

export function usePortfolio() {
  const [balances, setBalances] = useState({ usdc: 0 });
  const [positions, setPositions] = useState([]);
  const [ledger, setLedger] = useState([]);
  const [loading, setLoading] = useState(true);
  

  useEffect(() => {
    const u = auth.currentUser;
    if (!u) { setLoading(false); return; }

    setLoading(true);

    const unsubs = [];

    // users/{uid} баланс
    unsubs.push(
      onSnapshot(doc(db, "users", u.uid), (snap) => {
        const d = snap.data() || {};
        const b = d.balance || {};
        setBalances({
          usdc: Number(b.usdc ?? b.USDC ?? 0),
        });
      })
    );

    // positions: открытые/закрытые позиции по рынкам
    unsubs.push(
      onSnapshot(
        query(collection(db, "positions"), where("userId", "==", u.uid), orderBy("updatedAt", "desc"), limit(200)),
        (snap) => setPositions(snap.docs.map(x => ({ id: x.id, ...x.data() })))
      )
    );

    // ledger: сделки/депозиты/выводы/settlement
    unsubs.push(
      onSnapshot(
        query(collection(db, "ledger"), where("userId", "==", u.uid), orderBy("timestamp", "desc"), limit(200)),
        (snap) => {
          setLedger(snap.docs.map(x => ({ id: x.id, ...x.data() })));
          setLoading(false);
        }
      )
    );

    return () => unsubs.forEach(fn => fn());
  }, []);

  // PnL пока считаем агрегированно из positions (позже будет серверная truth)
  const pnl = useMemo(() => {
    const realized = positions.reduce((s, p) => s + Number(p.realizedPnl ?? 0), 0);
    const unrealized = positions.reduce((s, p) => s + Number(p.unrealizedPnl ?? 0), 0);
    return { realized, unrealized, total: realized + unrealized };
  }, [positions]);

  return { balances, pnl, positions, ledger, loading };
}
